import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

export default function SectionLayout({ links }) {
  return (
    <div className="flex h-full">
      {/* Desktop sidebar */}
      <aside className="hidden md:flex w-48 bg-white border-r border-gray-100 flex-col py-4 shrink-0">
        <nav className="flex flex-col gap-0.5 px-2">
          {links.map(({ to, label, icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors ${
                  isActive
                    ? 'bg-indigo-50 text-indigo-700 font-medium'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`
              }
            >
              <SafeIcon icon={icon} size={15} />
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Mobile horizontal nav */}
      <div className="md:hidden fixed top-14 left-0 right-0 bg-white border-b border-gray-100 z-20">
        <nav className="flex overflow-x-auto scrollbar-hide px-3 py-1.5 gap-1">
          {links.map(({ to, label, icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors shrink-0 ${
                  isActive
                    ? 'bg-indigo-100 text-indigo-700'
                    : 'text-gray-500 hover:bg-gray-100'
                }`
              }
            >
              <SafeIcon icon={icon} size={13} />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Page content */}
      <div className="flex-1 overflow-y-auto bg-gray-50 p-6 md:pt-6 pt-16">
        <Outlet />
      </div>
    </div>
  );
}
